/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as DraftDefs from './defs.defs'

const $nsid = 'com.sunnahsky.article.draft.createDraft'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  draft: /*#__PURE__*/ l.ref<DraftDefs.Draft>((() => DraftDefs.draft) as any),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  id: /*#__PURE__*/ l.string({ format: 'tid' }),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Inserts an article draft using private storage (stash). Requires authentication and Striker role - a non-Striker account or a Striker at their drafts limit will be rejected. THIS IS A TEMPORARY UNSPECCED ROUTE, specific to this fork's article-authoring feature. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'NotAStriker',
  'ArticleDraftLimitReached',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
